import { connect } from 'react-redux'

import SignUp from './SignUp'
import {
  validateEmail,
  validateFirstName,
  validateLastName,
  validatePassword,
  validatePasswordConfirmation,
  fetchSignUp
} from './signUpActions'

const mapStateToProps = state => ({
  inputValues: state.signUp.inputValues,
  validationErrors: state.signUp.validationErrors,
  isSignUpRequestPending: state.signUp.isSignUpRequestPending,
  isSignUpRequestSuccessful: state.signUp.isSignUpRequestSuccessful,
  isSignUpRequestError: state.signUp.isSignUpRequestError
})

const mapDispatchToProps = dispatch => {
  return {
    onEmailInputChange: (newInput) => dispatch((validateEmail(newInput))),
    onFirstNameInputChange: (newInput) => dispatch((validateFirstName(newInput))),
    onLastNameInputChange: (newInput) => dispatch((validateLastName(newInput))),
    onPasswordInputChange: (newInput) => dispatch((validatePassword(newInput))),
    onPasswordConfirmationInputChange: (newInput) => dispatch((validatePasswordConfirmation(newInput))),
    onFormSubmit: (inputValues) => dispatch(fetchSignUp(inputValues))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp)
